import {Task} from "../Task.js";
import {LoadError} from '../LoadError.js';
import {warn} from '../logfunctions.js';
import {LoadJSONTask} from '../LoadJSONTask.js';
import {COMPLETE, FAIL} from '../constants.js';

/**
 * A general base class for sending HTTP requests to Editor Service.
 */
export class EditorServiceRequestTask extends Task {
  constructor (name, method, env, studioSessionToken) {
    super();
    this.name = name;
    this.method = method;
    this.env = env;
    this.studioSessionToken = studioSessionToken;
  }

  start () {
    super.start();

    let loadJSONTask = new LoadJSONTask(this.getFullURL(),
      {
        headersObj:
          {
            'Authorization':
              `Token token=${this.studioSessionToken}`
          },
        method: this.method
      });
    loadJSONTask.on(COMPLETE, () => {
      this.onSuccess(loadJSONTask.json);
      this.done();
    });
    loadJSONTask.on(FAIL, (e) => {
      // Data failed to load
      let error = e.detail.error;
      if (error instanceof LoadError) {
        if (error.HTTPStatus === 404) {
          warn(`Editor Service request failed. The project or resource was not found (404). URI: ${error.uri}`);
        } else {
          warn(`Editor Service request failed. HTTP status ${error.HTTPStatus}. URI: ${error.uri}`);
        }
      } else {
        warn('Editor Service request failed. Either the Internet connection is unavailable '
          + 'or an error occurred retrieving the resource from Editor Service.');
      }
      this.fail('Editor Service request failed.');
    });
    loadJSONTask.start();
  }

  getFullURL () {
    return this.getBaseURL() + this.getScope() + this.getPath();
  }

  getBaseURL () {
    return `https://editor-${this.env}.herokuapp.com/api/v1`;
  }

  getScope () {
    return '';
  }

  getPath () {
    // To be implemented by subclasses
    return '';
  }

  onSuccess (data) {
    // To be implemented by subclasses
  }
}

